export default __webpack_public_path__ + "static/icon-callout-ida-dosing-545bd33468863baa1e85218c1f5be2a6.png";